import { ICommonInputProps } from "../../../shared/commonTypes/commonTypes";

export enum LoginInputKeys {
    LOGIN_INPUT = 'loginInput',
    PASSWORD_INPUT = 'passwordInput',
}

export type ILoginFormStore = Record<LoginInputKeys, ICommonInputProps>;

export interface ILoginInputs {
    label: string;
    inputName: keyof ILoginFormStore
}